import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { DyanamicFieldsFormModule } from '../dyanamic-fields-form/dyanamic-fields-form.module';
import { MaterialModule } from '../material/material.module';
import { AlertComponent } from './components/alert/alert.component';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DateComponent } from './components/date/date.component';
import { ErrorMsgDialogComponent } from './components/error-msg-dialog/error-msg-dialog.component';
import { NoteMsgComponent } from './components/note-msg/note-msg.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PopupModelComponent } from './components/popup-model/popup-model.component';
import { PremiumTableComponent } from './components/premium-table/premium-table.component';
import { ShowJobStatusComponent } from './components/show-job-status/show-job-status.component';
import { ShowMemberUploadFilesComponent } from './components/show-member-upload-files/show-member-upload-files.component';
import { WelcomeEmailTimeGridComponent } from './components/welcome-email-time-grid/welcome-email-time-grid.component';
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { SearchFilterPipe } from './pipes/search.pipe';

@NgModule({
  declarations: [
    AlertComponent,
    PageNotFoundComponent,
    AuthCallbackComponent,
    SearchFilterPipe,
    NumberFormatPipe,
    ConfirmDialogComponent,
    ErrorMsgDialogComponent,
    PopupModelComponent,
    DateComponent,
    NoteMsgComponent,
    PremiumTableComponent,
    ShowJobStatusComponent,
    WelcomeEmailTimeGridComponent,
    ShowMemberUploadFilesComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    DyanamicFieldsFormModule,
    SlickCarouselModule,
    BsDatepickerModule.forRoot(),
  ],
  exports: [
    AlertComponent,
    PageNotFoundComponent,
    SearchFilterPipe,
    NumberFormatPipe,
    MatButtonModule,
    MatDialogModule,
    PopupModelComponent,
    DateComponent,
  ],
  providers: [],
})
export class SharedModule {}
